import __request__ from "routing/request";
export function list(sort = "initiator_id", page = 1, per_page = 50, query, order = "asc", requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.collections/membership_policies", null, { "page": page, "per_page": per_page, "query": query, "sort": sort, "order": order }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function create(request, requestOptions) {
  return __request__("POST", "/plugins/org.graylog.plugins.collections/membership_policies", request, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function loadPermittedDefaultCollections(userId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.collections/membership_policies/default_collections/${userId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getByInitiatorId(initiatorType, initiatorId, requestOptions) {
  return __request__("GET", "/plugins/org.graylog.plugins.collections/membership_policies/initiator", null, { "initiatorType": initiatorType, "initiatorId": initiatorId }, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function update(policyId, updateRequest, requestOptions) {
  return __request__("PUT", `/plugins/org.graylog.plugins.collections/membership_policies/${policyId}`, updateRequest, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function get(policyId, requestOptions) {
  return __request__("GET", `/plugins/org.graylog.plugins.collections/membership_policies/${policyId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function remove(policyId, requestOptions) {
  return __request__("DELETE", `/plugins/org.graylog.plugins.collections/membership_policies/${policyId}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
